import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';
import { replaceMessagesWithUploadedFiles } from '../utils';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const editKeywordRule: prophetTypes.EditKeywordRule = async (data, pageId) => {
  const messagesWithUrls = await replaceMessagesWithUploadedFiles(data.messages, pageId);
  return axios.patch(`/prophet/keyword-rules`, { ...data, messages: messagesWithUrls });
};

type EditKeywordRuleOptions = {
  pageId: string;
  config?: MutationConfig<typeof editKeywordRule>;
};

export function useEditKeywordRule({ config = {}, pageId }: EditKeywordRuleOptions) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      toasts.loadingToast.loading('edit-keyword-rule');
      config.onMutate?.(...args);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['keyword-rules', pageId]);
      toasts.loadingToast.success('edit-keyword-rule');
      config.onSuccess?.(...args);
    },
    onError: (...args) => {
      toasts.loadingToast.error('edit-keyword-rule');
      config.onError?.(...args);
    },
    mutationFn: (data) => editKeywordRule(data, pageId),
  });
}
